

import { Component, Prop, Vue } from "vue-property-decorator"

import { ErrorInfo } from "@/types/error"

@Component({})
export default class ErrorDisplay extends Vue {
    @Prop({ required: true })
    error!: ErrorInfo | null
}
